import React, { ReactElement } from 'react';
import { Modal } from '@odin-labs/components';
import { ArrowRotateLeftIcon } from 'components/icons';
import { Schedule } from 'containers/jobsite/tabs/jobsiteSchedules/data/types';

export function ResetScheduleModal(props: {
  isOpen: boolean;
  closeModal: () => void;
  onConfirm?: () => void;
  selectedSchedule: Schedule;
}): ReactElement {
  const { isOpen, closeModal, selectedSchedule } = props;

  const onAction = (): void => {
    // TODO: [sc-13274] Implement reset schedule logic
    // eslint-disable-next-line no-console
    console.log('Resetting schedule for:', selectedSchedule?.id);
    closeModal();
  };

  return (
    <Modal
      actionButtonTheme="danger"
      actionIcon={ArrowRotateLeftIcon}
      actionText="Reset schedule"
      onAction={onAction}
      open={isOpen}
      setOpen={closeModal}
      size="xs"
      textAlignment="center"
      title="Are you sure you want to reset this schedule?"
      titleAlignment="center"
    />
  );
}
